/**
 * "Remember me" persistence for the login flow.
 * Mirrors the mobile app: only the identifier is stored, never the password.
 */
import { storage } from '@wlb/shared/platform/storage';
import { STORAGE_KEYS } from '@wlb/shared/constants';

interface RememberedCredentials {
  email?: string;
  rememberMe?: boolean;
}

// Storage is unavailable or quota-bound in private browsing modes. Remembering
// the identifier is a convenience, so a failure here must never abort sign-in.
export async function getRememberedEmail(): Promise<string> {
  try {
    const saved = await storage.getItem<RememberedCredentials>(
      STORAGE_KEYS.REMEMBER_ME_CREDENTIALS,
    );
    return saved?.rememberMe && saved.email ? saved.email : '';
  } catch {
    return '';
  }
}

export async function setRememberedEmail(email: string): Promise<void> {
  try {
    await storage.setItem(STORAGE_KEYS.REMEMBER_ME_CREDENTIALS, {
      email,
      rememberMe: true,
    });
  } catch {
    /* keep signing in without the saved identifier */
  }
}

export async function clearRememberedEmail(): Promise<void> {
  try {
    await storage.removeItem(STORAGE_KEYS.REMEMBER_ME_CREDENTIALS);
  } catch {
    /* keep signing in without clearing the saved identifier */
  }
}
